import { assertNever } from '@cronos-app/utils';
import { ChainId } from '../types';
export { ADDRESS_BY_CHAIN_L1, } from './address';
export { ADDRESS_BY_CHAIN_CRONOS_EVM, } from './address_cronos_evm';
export { ADDRESS_BY_CHAIN_L2, } from './address_l2';
export { MIN_AMOUNT_PRELAUNCH_DEPOSIT, MIN_LCRO_AMOUNT_PRELAUNCH_DEPOSIT, MIN_ZKCRO_AMOUNT_WITHDRAW, } from './constants';
export const DEFAULT_NETWORK = process.env.APP_ENV === 'prod' || process.env.APP_ENV === 'uat'
    ? ChainId.ETHEREUM
    : ChainId.SEPOLIA;
export const getEnsAddress = (chainId) => {
    switch (chainId) {
        case ChainId.SEPOLIA:
        case ChainId.ZK_EVM_TEST:
        case ChainId.CRONOS_EVM_MAINNET:
        case ChainId.CRONOS_EVM_TESTNET:
        case ChainId.ETHEREUM:
        case ChainId.ZK_EVM:
            // TODO add ENS address here
            return;
        default:
            // make sure no chain id is forgotten above
            assertNever(chainId);
    }
};
